<template>
    <div>
        <AloUploadInline :value="value" @input="$emit('input', $event)" />
    </div>
</template>

<script>
import AloUploadInline from '@App/Vue/Alo/UploadInline.vue'

export default {
    components: { AloUploadInline },
    props: ['value', 'field'],
}
</script>
